import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom"
import React from "react"
import Layout from "./components/Layout"
import LoginPage from "./pages/LoginPage"
import DashboardPage from "./pages/DashboardPage"
import SummariesPage from "./pages/SummariesPage"
import AdminSettingsPage from "./pages/AdminSettingsPage"
import JobDescriptionPage from "./pages/JobDescriptionPage"
import { AuthWrapper } from "./context/AuthWrapper"

function useAuthCheck() {
  const [checking, setChecking] = React.useState(true)
  const [isAuthenticated, setIsAuthenticated] = React.useState(false)
  React.useEffect(() => {
    import("@aws-amplify/auth").then(({ getCurrentUser }) => {
      getCurrentUser()
        .then(() => setIsAuthenticated(true))
        .catch(() => setIsAuthenticated(false))
        .finally(() => setChecking(false))
    })
  }, [])
  return { checking, isAuthenticated }
}

function App() {
  // Helper to check if user is authenticated
  function RequireAuth({ children }: { children: JSX.Element }) {
    const { checking, isAuthenticated } = useAuthCheck()
    if (checking) return null
    if (!isAuthenticated) return <Navigate to="/login" replace />
    return children
  }

  // Custom LoginRoute to redirect to / if already authenticated
  function LoginRoute() {
    // Use Amplify's Authenticator context
    // We'll use getCurrentUser for a simple check
    const [checking, setChecking] = React.useState(true)
    const [isAuthenticated, setIsAuthenticated] = React.useState(false)
    React.useEffect(() => {
      import("@aws-amplify/auth").then(({ getCurrentUser }) => {
        getCurrentUser()
          .then(() => setIsAuthenticated(true))
          .catch(() => setIsAuthenticated(false))
          .finally(() => setChecking(false))
      })
    }, [])
    if (checking) return null
    if (isAuthenticated) return <Navigate to="/" replace />
    return <LoginPage />
  }

  return (
    <AuthWrapper>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route
            path="/"
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="summaries" element={<SummariesPage />} />
            <Route path="jobs" element={<JobDescriptionPage />} />
            <Route path="admin" element={<AdminSettingsPage />} />
          </Route>
        </Routes>
      </Router>
    </AuthWrapper>
  )
}

export default App
